import { Button, Checkbox, FormControl, FormControlLabel, FormGroup, Grid, InputLabel, MenuItem, Select, Step, StepLabel, Stepper, TextField, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react'
import { Controller, useForm, useFormContext } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import HouseHold from './HouseHold';
import { checkboxColorSx, roleOptions } from 'store/constant';
import axiosInstance from 'custom-axios';
import { toast } from 'react-toastify';
import { useParams } from 'react-router';

const RoleInformation = ({ roleRef, setHouseHoldHomeComponent, activeStep, setActiveStep }) => {

	const childSteps = ['Role', 'Personal Information', 'Address', 'Financial', 'Review']

	const { id } = useParams();

	/* const householdValidation = Yup.object().shape({
		role_type: Yup.string().required(),
		role_options: Yup.array().nullable().min(1, 'Please select at least one option')
	}); */

	const { handleSubmit, control, getValues, setValue, reset, trigger, formState: { errors } } = useFormContext();


	React.useImperativeHandle(roleRef, () => ({
		triggerValidation: async () => {
			const isValid = await trigger();
			return isValid;
		}
	}));

	const handleCheckboxChange = (option) => {
		let currentValues = getValues("role_options");

		// Convert string like "1,2,3" to an array of strings
		if (typeof currentValues === "string") {
			currentValues = currentValues.split(",");
		}

		// Ensure it's an array
		if (!Array.isArray(currentValues)) {
			currentValues = [];
		}

		const isChecked = currentValues.includes(option.toString());

		const updatedOptions = isChecked
			? currentValues.filter((item) => item !== option.toString())
			: [...currentValues, option.toString()];

		setValue("role_options", updatedOptions, {
			shouldValidate: true,
			shouldDirty: true,
			shouldTouch: true,
		});
	};


	const handleRoleBack = async () => {

		if (activeStep === 0) {
			setHouseHoldHomeComponent(false);
			return <HouseHold />
		} else {

			let endPoint = `api/change-form-step`;

			const submitData = { user_id: id, parent_step: 0, child_step: activeStep - 1 }

			try {
				const response = await axiosInstance.post(endPoint, submitData);

				if (response.status === 200) {
					setActiveStep(activeStep - 1);
				}

			} catch (error) {

				// console.error(error)
				toast.error('An error occurred when navigating back.')
			}

		}
	};

	const submitRoleForm = async (data) => {

		let endPoint = `api/save-user-role-info`;

		const submitData = { ...data, user_id: id, parent_step: 0, child_step: activeStep + 1 }

		try {
			const response = await axiosInstance.post(endPoint, submitData);

			if (response.status === 200) {
				setActiveStep(activeStep + 1);
				localStorage.setItem('user_get_id', response.user_id)
			}

		} catch (error) {
			// console.error(error)
		}
	}


	return (
		<div>
			{activeStep === childSteps.length ? (
				<div>
					{/* added one step to main parent step */}
					{/* <Typography>All steps completed od child steps - Parent</Typography> */}
					null
				</div>
			) : (

				// <div className='container form-box-shadow padding10px'>

				<form onSubmit={handleSubmit(submitRoleForm)}>
					<Grid container spacing={2} className='mt-4'>

						<Grid item xs={3} className='text-right align-content-center'>
							<label htmlFor="household_rr_code" className='font15px'>Role Type</label>
						</Grid>

						<Grid item xs={3}>
							<FormControl sx={{ minWidth: 280 }} size="small" error={Boolean(errors?.role_type)}>
								<InputLabel id="role_type-label">Role</InputLabel>

								<Controller
									name="role_type"
									control={control}
									defaultValue=""
									rules={{ required: "Please select a role" }}
									render={({ field: { onChange, value }, fieldState: { error } }) => (
										<Select
											labelId="role_type-label"
											id="role_type"
											label="Role"
											value={value}
											onChange={(e) => {
												onChange(e); // RHF state update
											}}
											classes={{ select: "custom-select-label" }}
											MenuProps={{
												disableScrollLock: true,
												PaperProps: { sx: { maxHeight: 200 } },
											}}
										>
											<MenuItem value={1}>Person</MenuItem>
											<MenuItem value={2}>Entity</MenuItem>
										</Select>
									)}
								/>
							</FormControl>

						</Grid>
						<Grid item xs={6}></Grid>


						{/*================ROle==============*/}
						<Grid item xs={3} className='text-right mt-3'>
							<label htmlFor="role" className='font15px'>Role</label>
						</Grid>

						<Grid item xs={3}>
							<FormGroup>
								{roleOptions.map((option, index) => {
									const roleValues = getValues("role_options");
									const selectedRoles = Array.isArray(roleValues)
										? roleValues.map(String)
										: typeof roleValues === "string"
											? roleValues.split(",")
											: [];

									return (
										<FormControlLabel
											key={index}
											control={
												<Checkbox
													sx={checkboxColorSx}
													checked={selectedRoles.includes(option.value.toString())}
													onChange={() => handleCheckboxChange(option.value)}
												/>
											}
											label={option.label}
										/>
									);
								})}
							</FormGroup>



							{errors.role_options && <p>{errors.role_options.message}</p>}
						</Grid>
						<Grid item xs={6}></Grid>
					</Grid>

					<Grid item xs={12} sm={6} className='pt-3 text-center'>
						<Button variant='contained' className='m-3 raintree-btn-green' onClick={handleRoleBack}>
							Back
						</Button>
						<Button variant='contained' className='m-3 raintree-btn-green' type='submit'>
							Next
						</Button>
					</Grid>


				</form>
				// </div>
			)}
		</div >
	)
}

export default RoleInformation